export class EventLogService {
  _waifus = ['Anastasia', 'Vicky', 'Lisa', 'Elen', 'Janet', 'Jessica', 'Samantha', 'Paula', 'Melina', 'Diana', 'Tina',
    'Annie', 'Helena', 'Sofia'];

  addHint(waifu, text) {
    if(typeof $gameSystem._eventLog[waifu] !== "string") return;
    $gameSystem._eventLog[waifu] = text;
  }

  tbdHint(waifu) {
    if(typeof $gameSystem._eventLog[waifu] !== "string") return;
    $gameSystem._eventLog[waifu] = 'More content cumming soon.';
  }

  hasHint(waifu) {
    if(!$gameSystem._eventLog[waifu]) return false;
    return !($gameSystem._eventLog[waifu] && $gameSystem._eventLog[waifu].length === 0);
  }

  removeHint(waifu) {
    if(!$gameSystem._eventLog[waifu]) return;
    $gameSystem._eventLog[waifu] = '';
  }

  getHints() {
    return $gameSystem._eventLog;
  }

  createEventLogData() {
    const eventLog = {};
    const waifuLength = this._waifus.length;

    for(let i = 0; i < waifuLength; i++) {
      eventLog[this._waifus[i]] = '';
    }

    return eventLog;
  }
}
